<script setup lang="ts">
    type Props = {
        loading?: boolean;
    };

    const props = withDefaults(defineProps<Props>(), {
        loading: false
    });
</script>

<template>
    <b-tag
        :class="{'is-loading': props.loading}"
        class="button is-static px-3"
        rounded>
        <slot v-if="!props.loading" />
    </b-tag>
</template>
<style scoped>
.button.is-static {
    bottom: -0.5ex;
    /* Increase contrast over static button's default. Color taken from tab text */
    color: hsl(0, 0%, 29%);
}
</style>
